import React from "react";
import { Box, Paper } from "@mui/material";

export const BasicModalContainer = (props) => {
  const { children } = props;

  return (
    <Box
      sx={{
        padding: "10px 0px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

BasicModalContainer.defaultProps = {};
